const ActionLabels = Object.freeze({
  return: 'Returned',
  takeOwnership: 'Ownership taken',
  next: 'Started',
  approve: 'Approved',
  reject: 'Rejected',
});

export default ActionLabels;
